"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Id = undefined;

var _types = require("../users/types");

exports.Id = _types.Id;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2Uvb3B0aW9ucy90eXBlcy5qcyJdLCJuYW1lcyI6WyJJZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztRQUNRQSxFIiwiZmlsZSI6InR5cGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7SWR9IGZyb20gXCIuLi91c2Vycy90eXBlc1wiXG5leHBvcnQge0lkfVxuXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHtcbiAgK251bWJlcmZvcm1hdD86IHN0cmluZyxcbiAgK2lzRGVidWc/OiBib29sZWFuLFxuICArcHJlcmVsZWFzZUZsYWdzPzogYm9vbGVhbixcbn1cblxuZXhwb3J0IHR5cGUgUHJvcHMgPSB7fVxuZXhwb3J0IHR5cGUgU2VsZWN0PFQ+ID0gKFN0YXRlLCBhbnkpID0+IFRcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/options/types.js
// module id = 789
// module chunks = 0